module.exports = __webpack_public_path__ + "static/media/fractalIcon.41c297aa.svg";